<!--
 * @Author: lixiaodi
 * @Date: 2020-03-13 09:21:21
 * @LastEditors: lixiaodi
 * @LastEditTime: 2020-06-24 11:01:44
 -->
 <template>
    <div class="share-box">
        <!-- 标题 -->
        <model-title :content="title"></model-title>
        <!-- 资源简介 -->
        <div class="share-content">
            <div class="share-resource" v-if="shareList[0]" @click="toImg(shareList[0].VAttachmentId)">
                <div class="resource-img">
                    <img v-if="shareList[0] && shareList[0].VAttachmentRemotePath" :src="shareList[0].VAttachmentRemotePath" alt="book">
                    <p v-else>暂无封面</p>
                </div>
                <div class="resource-info">
                    <div class="info-title">
                        <p v-if="shareList">{{shareList[0].VAttachmentName ? shareList[0].VAttachmentName : '--'}}</p>
                        <!-- <p>{{shareList[0].VWriterName}}</p> -->
                    </div>
                    <div class="info-content">{{shareList[0].VAttachmentContent}}</div>
                </div>
            </div>
            <!-- 资源列表 -->
            <div class="share-list">
                <div class="list-item" v-for="(item,index) in shareList.slice(1)" :key="item.VAttachmentId" @click="toImg(item.VAttachmentId)">
                    <div class="item-left">
                        <p class="bookIcon"><i class="iconfont iconshuben"></i></p>
                        <p class="left-VProductName" >{{item.VAttachmentName ? item.VAttachmentName : '--'}}</p>
                    </div>
                    <div class="item-right">
                        <!-- <p>{{item.VWriterName}}</p> -->
                        <p style="margin-left: 1rem;width: 1rem;text-align: right;">浏览次数{{item.viewtime ? item.viewtime : '0'}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ModelTitle from './../../commonView/modelTitle'
export default {
    name: 'PicLaozhaoList',
    components: {
      ModelTitle,
    },
    data() {
        return {
            shareList: [],
            title: '老照片'
        }
    },
    created() {
        this.eduDataRes();
    },
    methods: {
        toImg(VProductId){
            console.log(VProductId)
            this.$router.push(
            {
                path: 'imageDetails',
                query: {
                VProductId: VProductId
                }
            }
            )
      },

        eduDataRes (){
            this.axios.post(window.IPConfig.IP + '/tBAttachments/queryauditStatusPage.do?auditStatus=1',
            {
                auditStatus: "1",
              VAttachmentType: "1",
              size: 6,
              current: 0,
              categoryname:'老照片'
            }
            ).then((response) => {
                if (response.status == 200) {
                    if (response.data.status == 200) {
                        console.log(response.data.obj)
                        // 列表赋值
                        this.shareList = response.data.obj.records;
                    }
                }
            })
        }
    }
}
</script>
<style lang="stylus" scoped>
.share-box{
    /* padding .1rem */
}
/* 标题 */
.share-title{
    display flex
    justify-content space-between
    border-left 2px solid #228457
    padding-left: 0.1rem;
}
.title-sty{
    font-weight 700
}
.title-more{
    color #46454c
    cursor pointer
}
.share-content {
    padding 0 0.1rem
}
/* 资源简介 */
.share-resource{
    border-top 1px solid #efefef
    padding .1rem
    display flex
    flex-flow row nowrap
    /* align-items center */
    justify-content space-between;
    height: 1.2rem;
    overflow: hidden;
}
.resource-img{
  padding .1rem .1rem
  //background  rgba(0,176,135,0.2)
  width: 2rem;
  height: 1rem;
  line-height: .8rem;
  text-align: center;
  cursor :pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.resource-img img{
  max-width: 100%;
  max-height: 100%;
}
.resource-info{
    width: 100%;
    margin-left: .3rem;
    height: 1.5rem;
    overflow: hidden;
}
.info-title{
    display flex
    justify-content space-between
    line-height 3
    border-bottom 1px solid #efefef
    margin-bottom .1rem
}
.info-content {
  line-height 1.5;
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  word-break: break-all;
  -webkit-box-orient: vertical;
  text-indent 0.2rem;
}
/* 资源列表 */
.list-item{
    display flex
    flex-flow row nowrap
    line-height 2
    justify-content space-between
    align-items: center;
    cursor pointer
}
.list-item:hover {
    background rgba(0,176,135,.1)
}
.item-left{
    display flex
    flex-flow row nowrap
    align-items center
}
.item-right{
    display flex
    flex-flow row nowrap
}
.bookIcon{
    color #22c6b6
}
.left-VProductName{
    margin-left: .06rem;
    white-space: nowrap;
    text-overflow: ellipsis;
    word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/components/Education/components/index/picLaozhaoList.vue